if (window.innerWidth < 768) {
    $(document).on('click', '.footer-menu__title-js', ({target}) => {
        const currentElement = $(target).closest('.footer-menu__title-js');
        currentElement.siblings('.footer-menu__items').slideToggle();

        if (currentElement.hasClass('footer-menu__title_active')) {
            currentElement.find('use').attr('xlink:href', '#svg-plus');
        } else {
            currentElement.find('use').attr('xlink:href', '#svg-minus');
        }

        currentElement.toggleClass('footer-menu__title_active');
    })
}